import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { KomodoCoreWrappersModule } from '@komodo-design-system/komodo-core-angular-twelve-wrappers/dist/komodo-core-wrappers';
import { KwaAngular18Module } from '@komodo-design-system/komodo-kwa-angular-18';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { AiSummaryModule } from './components/ai-summary/ai-summary.module';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { CdsTooltipModule } from './components/cds-tooltip/cds-tooltip.module';
import { ChartModule } from './components/chart/chart.module';
import { ChipsListModule } from './components/chips-list/chips-list.module';
import { ConfirmationModalComponent } from './components/confirmation-modal/confirmation-modal.component';
import { DrilldownChartContainerModule } from './components/drilldown-chart-container/drilldown-chart-container.module';
import { DrilldownChartNoDataAvailableModule } from './components/drilldown-chart-no-data-available/drilldown-chart-no-data-available.module';
import { DrilldownTableModule } from './components/drilldown-table/drilldown-table.module';
import { DrilldownChartToggleModule } from './components/drilldown-toggle-chart/drilldown-toggle-chart.module';
import { ErrorViewComponent } from './components/error-view/error-view.component';
import { ExpandedPanelModule } from './components/expanded-panel/expanded-panel.module';
import { ExpandedViewModule } from './components/expanded-view/expanded-view.module';
import { FeedbackCardComponent } from './components/feedback-card/feedback-card.component';
import { GridPanelContainerModule } from './components/grid-panel-container/grid-panel-container.module';
import { GroupedBarChartModule } from './components/grouped-bar-chart/grouped-bar-chart.module';
import { KpiCardModule } from './components/kpi-card/kpi-card.module';
import { KpiTooltipModule } from './components/kpi-tooltip/kpi-tooltip.module';
import { KpiTrendIndicatorModule } from './components/kpi-trend-indicator/kpi-trend-indicator.module';
import { LoadingWheelComponent } from './components/loading-wheel/loading-wheel.component';
import { LogoutModule } from './components/logout/logout.module';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { ProviderModalComponent } from './components/provider-modal/provider-modal.component';
import { SessionExtendModalComponent } from './components/session-extend-modal/session-extend-modal.component';
import { SidePanelModule } from './components/side-panel/side-panel.module';
import { SimpleCardModule } from './components/simple-card/simple-card.module';
import { StatusBadgeModule } from './components/status-badge/status-badge.module';
import { TimeCycleChartModule } from './components/time-cycle-chart/time-cycle-chart.module';
import { ToggleModule } from './components/toggle/toggle.module';
import { TrendChartModule } from './components/trend-chart/trend-chart.module';
import { FeatureFlagDirective } from './directives/feature-flag/feature-flag.directive';
import { HeaderMenuMilestoneModule } from './pages/study-portfolio/components/header-menu-milestone/header-menu-milestone.module';
import { SharedPipesModule } from './pipes/shared-pipes.module';

@NgModule({
  declarations: [
    PageHeaderComponent,
    BreadcrumbComponent,
    LoadingWheelComponent,
    ConfirmationModalComponent,
    ProviderModalComponent,
    SessionExtendModalComponent,
    FeedbackCardComponent,
    ErrorViewComponent,
    FeatureFlagDirective
  ],
  imports: [
    CommonModule,
    KomodoCoreWrappersModule,
    ExpandedPanelModule,
    GridPanelContainerModule,
    SidePanelModule,
    MatButtonModule,
    MatIconModule,
    ChartModule,
    GroupedBarChartModule,
    KwaAngular18Module,
    NgxSkeletonLoaderModule,
    KpiCardModule,
    KpiTooltipModule,
    KpiTrendIndicatorModule,
    DrilldownChartContainerModule,
    DrilldownChartNoDataAvailableModule,
    DrilldownTableModule,
    TrendChartModule,
    ChipsListModule,
    StatusBadgeModule,
    ToggleModule,
    DrilldownChartToggleModule,
    CdsTooltipModule,
    ExpandedViewModule,
    SimpleCardModule,
    SharedPipesModule,
    AiSummaryModule,
    LogoutModule,
    HeaderMenuMilestoneModule
  ],
  exports: [
    CommonModule,
    PageHeaderComponent,
    BreadcrumbComponent,
    LoadingWheelComponent,
    SidePanelModule,
    TimeCycleChartModule,
    ExpandedPanelModule,
    KpiCardModule,
    KpiTooltipModule,
    GridPanelContainerModule,
    DrilldownChartContainerModule,
    ChartModule,
    GroupedBarChartModule,
    MatButtonModule,
    MatIconModule,
    NgxSkeletonLoaderModule,
    CdsTooltipModule,
    ExpandedViewModule,
    KpiTrendIndicatorModule,
    DrilldownChartNoDataAvailableModule,
    DrilldownTableModule,
    TrendChartModule,
    ChipsListModule,
    StatusBadgeModule,
    ToggleModule,
    DrilldownChartToggleModule,
    ConfirmationModalComponent,
    ProviderModalComponent,
    FeedbackCardComponent,
    ErrorViewComponent,
    SimpleCardModule,
    SharedPipesModule,
    AiSummaryModule,
    FeatureFlagDirective,
    SessionExtendModalComponent,
    LogoutModule,
    HeaderMenuMilestoneModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule {}
